import { Component, OnInit } from '@angular/core';
import { CategoryService } from './category.service';
import { CategoryDto } from './category.model';

@Component({
  standalone: false,
  selector: 'app-categories-list',
  template: `
    <div>
      <div class="flex items-center justify-between mb-4">
        <h2 class="text-2xl font-serif">Categorias</h2>
        <a routerLink="/admin/categories/new" class="bg-primary text-white px-4 py-2 rounded-full">Nova Categoria</a>
      </div>

      <div *ngIf="items.length === 0">
        <p>Nenhuma categoria encontrada.</p>
      </div>

      <table class="w-full table-auto">
        <thead>
          <tr>
            <th class="text-left">Imagem</th>
            <th class="text-left">Nome</th>
            <th class="text-left">Slug</th>
            <th class="text-left">Ordem</th>
            <th class="text-left">Descrição</th>
            <th class="text-right">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of items">
            <td class="w-24">
              <div *ngIf="getImageUrl(c); else noimg">
                <img [src]="getImageUrl(c)" class="h-12 w-12 object-cover rounded" />
              </div>
              <ng-template #noimg><div class="h-12 w-12 bg-surface rounded flex items-center justify-center text-xs text-muted">Sem imagem</div></ng-template>
            </td>
            <td>{{ c.nome }}</td>
            <td>{{ c.slug }}</td>
            <td>{{ c.order ?? '—' }}</td>
            <td class="text-sm text-gray-500 max-w-xs truncate">{{ c.descricao || '—' }}</td>
            <td class="text-right">
              <a [routerLink]="['/admin/categories', c.id, 'edit']" class="mr-2">Editar</a>
              <button (click)="onDelete(c.id)" class="text-red-600">Excluir</button>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="flex items-center justify-between mt-4">
        <div>Mostrando {{ items.length }} de {{ total }} categorias</div>
        <div class="flex gap-2">
          <button (click)="prev()" [disabled]="page <= 1" class="px-3 py-1 border rounded">Anterior</button>
          <div class="px-3 py-1">Página {{ page }}</div>
          <button (click)="next()" [disabled]="page * pageSize >= total" class="px-3 py-1 border rounded">Próxima</button>
        </div>
      </div>
    </div>
  `
})
export class CategoriesListComponent implements OnInit {
  items: CategoryDto[] = [];
  page = 1;
  pageSize = 20;
  total = 0;

  constructor(private svc: CategoryService) {}

  getImageUrl(c: any) {
    // try common property names returned by the API (prefer `imageUrl`)
    if (c.imageUrl) return c.imageUrl;
    const media = c.media || c.imagem || c.image || null;
    if (media && (media.url || media.Url)) return media.url || media.Url;
    // no URL available
    return undefined;
  }

  ngOnInit(): void {
    this.load();
  }

  load() {
    this.svc.adminList(this.page, this.pageSize).subscribe((res: any) => {
      // backend may return either { data: [], meta: { ... } } or a plain array
      if (Array.isArray(res)) {
        this.items = res as CategoryDto[];
        this.total = this.items.length;
      } else {
        this.items = res?.data ?? [];
        this.total = res?.meta?.total ?? (this.items.length || 0);
        this.page = res?.meta?.page ?? this.page;
        this.pageSize = res?.meta?.pageSize ?? this.pageSize;
      }
    });
  }

  onDelete(id: string) {
    if (!confirm('Deseja excluir esta categoria?')) return;
    this.svc.delete(id).subscribe(() => this.load());
  }

  prev() {
    if (this.page > 1) { this.page--; this.load(); }
  }

  next() {
    if (this.page * this.pageSize < this.total) { this.page++; this.load(); }
  }
}
